"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalMock = exports.LocalMockBase = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
// filepath: /Users/n128691/PROJECTS/ARCH_WEB/MBWEB-mb-ui-framework/app/src/local-mock/local-mock.component.tsx
const react_1 = require("react");
const local_mock_util_1 = require("./local-mock.util");
const item_component_1 = __importDefault(require("./components/item.component"));
const local_mock_constants_1 = require("./local-mock.constants");
const local_mock_hook_1 = require("./local-mock.hook");
const containerStyle = {
    background: 'rgba(0, 0, 0, 0.3)',
    position: 'fixed',
    inset: '0 0 0 0',
    zIndex: 10000,
};
const modalStyle = {
    position: 'fixed',
    border: '1px solid grey',
    borderRadius: '5px',
    top: '2.5%',
    left: '50%',
    transform: 'translateX(-50%)',
    padding: '10px',
    background: 'white',
    maxHeight: '95vh',
    width: '700px',
    maxWidth: '60vw',
    display: 'flex',
    flexDirection: 'column',
};
const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '5px',
};
const labelStyle = {
    display: 'flex',
    alignItems: 'center',
};
const labelInputStyle = {
    marginRight: '5px',
};
const resetButtonStyle = {
    marginBottom: '5px',
    marginRight: '10px',
};
const closeButtonStyle = {
    cursor: 'pointer',
};
const listStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
};
const DEFAULT_CONSTANTS = {};
function LocalMockBaseNoMemoized({ constants = DEFAULT_CONSTANTS, innerRef }) {
    const [show, setShow] = (0, react_1.useState)(false);
    const [enable, setEnable] = (0, react_1.useState)(local_mock_util_1.getLocalMockEnabled);
    const [enableAll, setEnableAll] = (0, react_1.useState)(false);
    const [localMock, setLocalMock] = (0, react_1.useState)(local_mock_util_1.localMockStore);
    const [filter, setFilter] = (0, react_1.useState)('');
    const filteredKeys = (0, react_1.useMemo)(() => {
        if (filter) {
            return local_mock_util_1.sortedKeys.filter(key => key.includes(filter));
        }
        return local_mock_util_1.sortedKeys;
    }, [filter]);
    const handleLocalMockChange = (0, react_1.useCallback)((value) => {
        setLocalMock(state => {
            const localMockStoreState = { ...state, ...value };
            (0, local_mock_util_1.setLocalMockStore)(localMockStoreState);
            return localMockStoreState;
        });
    }, []);
    const showLocalMock = () => {
        setShow(true);
    };
    const handleResetClick = () => {
        (0, local_mock_util_1.removeLocalMockStore)();
        window.location.reload();
    };
    const handleCloseClick = () => {
        setShow(false);
    };
    const handleChange = () => {
        setEnable(!enable);
    };
    const handleFilterChange = ({ target }) => {
        setFilter(target.value);
    };
    const handleEnableAllChange = () => {
        setEnableAll(!enableAll);
        Object.entries(localMock).forEach(([id, mock]) => {
            const { [local_mock_constants_1.STATE]: state, ...value } = mock;
            handleLocalMockChange({
                [id]: { ...value, [local_mock_constants_1.STATE]: { ...state, enabled: !enableAll } },
            });
        });
    };
    (0, react_1.useImperativeHandle)(innerRef, () => ({ show: showLocalMock }));
    (0, react_1.useLayoutEffect)(() => {
        window.fetch = (0, local_mock_util_1.fetch)(constants);
    }, [constants]);
    (0, react_1.useEffect)(() => {
        window.showLocalMock = showLocalMock;
    }, []);
    (0, react_1.useEffect)(() => {
        (0, local_mock_util_1.setLocalMockEnabled)(enable);
    }, [enable]);
    return !show ? null : ((0, jsx_runtime_1.jsx)("div", { style: containerStyle, onClick: handleCloseClick, children: (0, jsx_runtime_1.jsxs)("div", { style: modalStyle, onClick: local_mock_util_1.stopPropagation, children: [(0, jsx_runtime_1.jsxs)("div", { style: headerStyle, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("button", { style: resetButtonStyle, onClick: handleResetClick, children: "Reset" }), (0, jsx_runtime_1.jsx)("input", { placeholder: "Filter", value: filter, onChange: handleFilterChange }), (0, jsx_runtime_1.jsxs)("label", { style: labelStyle, children: [(0, jsx_runtime_1.jsx)("input", { style: labelInputStyle, onChange: handleChange, type: "checkbox", checked: enable }), "Enable local mock"] }), (0, jsx_runtime_1.jsxs)("label", { style: labelStyle, children: [(0, jsx_runtime_1.jsx)("input", { style: labelInputStyle, onChange: handleEnableAllChange, type: "checkbox", checked: enableAll }), "Enable all individual mocks"] })] }), (0, jsx_runtime_1.jsx)("button", { "aria-label": "close", style: closeButtonStyle, onClick: handleCloseClick, children: "X" })] }), (0, jsx_runtime_1.jsx)("div", { style: listStyle, children: filteredKeys.map(key => {
                        return (0, jsx_runtime_1.jsx)(item_component_1.default, { id: key, localMock: localMock[key], onLocalMockChange: handleLocalMockChange }, key);
                    }) })] }) }));
}
exports.LocalMockBase = (0, react_1.memo)(LocalMockBaseNoMemoized);
const LocalMock = ({ context, constants = DEFAULT_CONSTANTS, innerRef, }) => {
    const load = (0, local_mock_hook_1.useInitializeLocalMock)(context);
    return !load ? null : (0, jsx_runtime_1.jsx)(exports.LocalMockBase, { constants: constants, innerRef: innerRef });
};
exports.LocalMock = LocalMock;
//# sourceMappingURL=local-mock.component.js.map